import { Collaboration } from "@back4app2/sdk";
import { DsButton, ModalDialog } from "../ds";
import { ReactComponent as TriangleExclamationIcon } from '../../assets/images/triangle-exclamation.svg';

export interface RemoveCollaboratorModalProps {
  open: boolean;
  collaborator: Collaboration | null;
  isRemoving: boolean;
  error: string;
  onClose: () => void;
  onConfirm: () => void;
}

export const RemoveCollaboratorModal = ({
  open,
  collaborator,
  isRemoving,
  error,
  onClose,
  onConfirm,
}: RemoveCollaboratorModalProps) => (
  <ModalDialog
    open={open}
    onClose={onClose}
    icon={<TriangleExclamationIcon className="text-state-err" width="20px" height="20px" />}
    title="Remove collaborator"
    blurb={<>
      {/* The address on its own run in mono: inline in the prose a long one
          broke mid-word, burying the one detail that identifies who this is. */}
      This removes <span className="font-courrier text-navy-100">{collaborator?.email}</span>{' '}
      from the app. They lose access immediately.
    </>}
    footer={<>
      <DsButton onClick={onClose} isDisabled={isRemoving}>Cancel</DsButton>
      <DsButton variant="danger" onClick={onConfirm} isDisabled={isRemoving}>
        {isRemoving ? 'Removing…' : 'Remove'}
      </DsButton>
    </>}
  >
    {error ? <span className="text-ds-115 text-state-err">{error}</span> : null}
  </ModalDialog>
);

export default RemoveCollaboratorModal;
